/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
import * as Types from '@/shared/types/types.generated';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseOffboardingApi } from '../../base-api';
export type OffboardingFragment = { __typename: 'OffboardingResponseType', offboardingId: string, deactivationTimestamp: any, dataPurgeTimestamp: any, tenantReactivated?: boolean, objectVersion?: number };

export type CreateOffboardingMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateOffboardingMutation = { __typename: 'Mutation', createOffboarding: { __typename: 'OffboardingResponseType', offboardingId: string, deactivationTimestamp: any, dataPurgeTimestamp: any, tenantReactivated?: boolean, objectVersion?: number } };

export type DeleteOffboardingMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DeleteOffboardingMutation = { __typename: 'Mutation', deleteOffboarding?: string };

export type ReadOffboardingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadOffboardingQuery = { __typename: 'Query', readAllOffboardings: { __typename: 'PaginatedOffboardingResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'OffboardingResponseType', offboardingId: string, deactivationTimestamp: any, dataPurgeTimestamp: any, tenantReactivated?: boolean, objectVersion?: number }> } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const OffboardingFragmentDoc = new TypedDocumentString(`
    fragment Offboarding on OffboardingResponseType {
  __typename
  offboardingId
  deactivationTimestamp
  dataPurgeTimestamp
  tenantReactivated
  objectVersion
}
    `, {"fragmentName":"Offboarding"});
export const CreateOffboardingDocument = new TypedDocumentString(`
    mutation CreateOffboarding {
  __typename
  createOffboarding {
    __typename
    ...Offboarding
  }
}
    fragment Offboarding on OffboardingResponseType {
  __typename
  offboardingId
  deactivationTimestamp
  dataPurgeTimestamp
  tenantReactivated
  objectVersion
}`);
export const DeleteOffboardingDocument = new TypedDocumentString(`
    mutation DeleteOffboarding {
  __typename
  deleteOffboarding
}
    `);
export const ReadOffboardingDocument = new TypedDocumentString(`
    query ReadOffboarding {
  __typename
  readAllOffboardings(pagination: {page: 1, pageSize: 1}) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...Offboarding
    }
  }
}
    fragment Offboarding on OffboardingResponseType {
  __typename
  offboardingId
  deactivationTimestamp
  dataPurgeTimestamp
  tenantReactivated
  objectVersion
}`);

const injectedRtkApi = baseOffboardingApi.injectEndpoints({
  overrideExisting: isHotReloadEnabled && module.hot?.status() === "apply",
  endpoints: (build) => ({
    CreateOffboarding: build.mutation<Types.CreateOffboardingMutation, Types.CreateOffboardingMutationVariables | void>({
      query: (variables) => ({ document: CreateOffboardingDocument as unknown as string, variables })
    }),
    DeleteOffboarding: build.mutation<Types.DeleteOffboardingMutation, Types.DeleteOffboardingMutationVariables | void>({
      query: (variables) => ({ document: DeleteOffboardingDocument as unknown as string, variables })
    }),
    ReadOffboarding: build.query<Types.ReadOffboardingQuery, Types.ReadOffboardingQueryVariables | void>({
      query: (variables) => ({ document: ReadOffboardingDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateOffboardingMutation, useDeleteOffboardingMutation, useReadOffboardingQuery, useLazyReadOffboardingQuery } = injectedRtkApi;

